import { BigNumber } from 'ethers'
import { formatUnits } from 'ethers/lib/utils'
import { AboutLockInfo, AboutLockInfoProps } from '~/components/AboutLockInfo'
import { renderAmount, toBigNumber } from '~/lib/helpers'
import { SIS_DECIMALS } from '~/lib/SISDecimals'

import styles from './AboutLockInfoWithChange.pcss'

type Props = AboutLockInfoProps & {
	change?: BigNumber | number
}

const CHANGE_VALUE = 0.01

export function AboutLockInfoWithChange({
	change,
	...props
}: Props): JSX.Element {
	let changeText: string

	return (
		<AboutLockInfo
			{...props}
			renderContent={(content) => {
				if (!change) {
					return content
				}

				let tooSmall
				let value
				if (BigNumber.isBigNumber(change)) {
					const changeValue = toBigNumber(
						SIS_DECIMALS,
						CHANGE_VALUE.toString()
					)

					tooSmall = change.lt(changeValue)
					value = renderAmount(formatUnits(change), 2)
				} else {
					tooSmall = change < CHANGE_VALUE
					value = renderAmount(change, 2)
				}

				return (
					<>
						<div className={styles.change}>
							<span className={styles.text}>
								{tooSmall ? `<${CHANGE_VALUE}` : `+${value}`}
							</span>
						</div>
						<div className={styles.content}>
							<span className={styles.text}>{content}</span>
						</div>
					</>
				)
			}}
		/>
	)
}
